import { Components as JoyComponents, Theme as JoyTheme } from '@mui/joy';
import JoyTab, { tabClasses } from '@mui/joy/Tab';
import JoyTabList from '@mui/joy/TabList';
import JoyTabPanel from '@mui/joy/TabPanel';
import JoyTabs from '@mui/joy/Tabs';
import { CSSInterpolation } from '@mui/system';

export const overrides: JoyComponents<JoyTheme> = {
  JoyTab: {
    defaultProps: { color: 'primary', variant: 'soft' },
    styleOverrides: {
      root: ({ ownerState, theme }) => {
        return {
          ...(ownerState.variant === 'soft' &&
            ({
              '--Tab-color': theme.palette.neutral[400],
              color: 'var(--Tab-color)',
              borderRightColor: theme.palette.neutral[200],
              backgroundColor: theme.palette.common.white,
              [`&:not(${tabClasses.selected}):hover`]: {
                '--Tab-color': theme.palette.primary.softColor,
                '--variant-softHoverBg': theme.palette.primary[50],
                '--variant-softHoverColor': theme.palette.primary[600],
              },
              [`&.${tabClasses.selected}`]: {
                '--Tab-color': theme.palette.neutral[800],
                '--variant-softActiveBg': theme.palette.primary[50],
              },
            } satisfies CSSInterpolation)),
        };
      },
    },
  },
  JoyTabList: {
    styleOverrides: {
      root: ({ ownerState, theme }) => {
        return {
          ...(ownerState.size === 'md' && {
            '--ListItem-paddingY': theme.spacing(1.25),
          }),
        };
      },
    },
  },
};

export const Tabs = JoyTabs;
export const Tab = JoyTab;
export const TabList = JoyTabList;
export const TabPanel = JoyTabPanel;
